const ar = {
  // Navbar
  favorites: 'المفضلة',
  cart: 'السلة',
  search: 'بحث...',
 youMayAlsoLike: "منتجات قد تعجبك",
  unitsInStock: "وحدة في المخزون",
  selectSize: "اختر المقاس",
  quantity: "الكمية",
  addtoCart: "أضف إلى السلة",
  outOfStock: "غير متوفر",
  cancel: "إلغاء",
  proceedtoCheckout:"إتمام الشراء",
  subtotal: "المجموع الفرعي",
  delivery: "التوصيل",
  "Delivery Cost": "تكلفة التوصيل",
  total: "المجموع",
  shoppingCart: "سلة التسوّق",
  cartIsEmpty: "سلتك فارغة",
  customerName: "اسم الزبون",
  customerPhone: "رقم الهاتف",
  village: "القرية",
  searchVillage: "ابحث عن قريتك...",
  selectVillage: "الرجاء اختيار القرية من القائمة.",
  optional: "اختياري",
  submitting: "جارٍ الإرسال...",
  enterCustomerName: "أدخل اسم الزبون",
  enterCustomerPhone: "مثال: 70123456",
  clear: "مسح",
  size: "المقاس",
  color: 'اللون',
  inStock: "متوفر",
  available: "متوفر",
  searchForOtherProducts: "ابحث عن المنتجات",
  startTyping: "ابدأ بكتابة للبحث عن المنتجات",
  searchError: "حدث خطأ أثناء البحث. يرجى المحاولة مرة أخرى.",
  noResultsFound: "لم يتم العثور على نتائج لـ",
  searching: "جاري البحث...",
  noMoreResults:"لا توجد نتائج أخرى",
  searchHistory:"سجل البحث",
  myOrders: "طلباتي",
  noSavedOrders: "لا توجد طلبات محفوظة.",
  orderPlaced: "تم إرسال الطلب بنجاح",
  orderNumber: "رقم الطلب",
  trackOrder: "تتبع الطلب",
  trackPackage: "تتبع الطرد",
  continueShopping: "متابعة التسوق",
  trackingUnavailable: "معلومات التتبع غير متوفرة أو انتهت صلاحيتها.",
  trackingExpired: "انتهت صلاحية رابط التتبع أو لم يعد صالحاً.",
  orderNotFound: "الطلب غير موجود.",
  tooManyRequests: "طلبات كثيرة جداً. يرجى المحاولة لاحقاً.",
  trackingLoadFailed: "تعذر تحميل الطلب.",
  loadingOrder: "جارٍ تحميل الطلب...",
  orderStatus: "حالة الطلب",
  paymentStatus: "حالة الدفع",
  shippingStatus: "حالة الشحن",
  orderDetails: "تفاصيل الطلب",
  orderItems: "عناصر الطلب",
  customer: "العميل",
  phone: "الهاتف",
  orderDate: "تاريخ الطلب",
  notes: "ملاحظات",

  showAll: 'عرض الكل ',
  loadMore: 'عرض المزيد',
  goBack: 'رجوع',
  failedToLoadProducts: 'فشل في تحميل المنتجات',
  product: 'منتج',
  products: 'منتجات',
  selectedColor: 'اللون المختار',
  selectColor : 'اختر اللون',

  // Slide Menu
  menu: 'القائمة',
  language: 'اللغة',
  followUs: 'تابعنا',
  information: 'معلومات',
  contactUs: 'اتصل بنا',
  privacyPolicy: 'سياسة الخصوصية',

  // Admin dashboard
  categories: "التصنيفات",
  orders: "الطلبات",
  coupons: "كوبونات الخصم",
  shippingCompanies: "شركات التوصيل",
  salesPoints: "نقاط المبيعات",
  merchantAccounts: "حسابات التجار",
  brands: "العلامات التجارية",
  eMarketing: "التسويق الإلكتروني",
  branchesAndWarehouses: "الفروع والمخازن",
  cities: "قائمة المدن",
  banners: "البنرات الإعلانية",
  videos: "فيديوهات العرض",
  ads: "الإعلانات",
  reviews: "آراء الزبائن",
  storePolicies: "سياسات المتجر",
  searchEngine: "محرك البحث",
  searchEngineFriends: "صداقة محركات البحث",
  settings: "إعدادات النظام",
  security: "الحماية والأمان",
  // Footer
  ourStore: 'متجرنا',
  storeDescription: 'نوفر لكم أفضل المنتجات بأعلى جودة وأفضل الأسعار. تسوق معنا واستمتع بتجربة فريدة.',
  quickLinks: 'روابط سريعة',
  home: 'الرئيسية',
  specialOffers: 'العروض الخاصة',
  aboutUs: 'من نحن',
  customerService: 'خدمة العملاء',
  returnPolicy: 'سياسة الإرجاع',
  shippingDelivery: 'الشحن والتوصيل',
  termsConditions: 'الشروط والأحكام',
  faq: 'الأسئلة الشائعة',
  contactInfo: 'تواصل معنا',
  location: 'فلسطين',
  workingHours: 'السبت - الخميس',
  workingTime: '9:00 ص - 9:00 م',
  copyright: '© 2025 جميع الحقوق محفوظة - متجرنا'
};
export default ar;
